// extracted by mini-css-extract-plugin
export default {"date":"historyMenu_date__AOS6j","companyName":"historyMenu_companyName__vK4Dp","companyLogo":"historyMenu_companyLogo__JKkrJ","headerSection":"historyMenu_headerSection__MMZWh"};